// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_r-0";
export var skeletonCard = "_r-1";